import request from "../utils/request";
//获取样式管理列表
export function getStyleList(params) {
  const styleName = encodeURIComponent(params.styleName || "");
  const styleType = params.styleType || "";
  const displayMode = encodeURIComponent(params.displayMode || "");
  return request({
    url: `/style/list?queryType=1&pageNum=${params.currentPage}&pageSize=${params.currentPageSize}&name=${styleName}&styleType=${styleType}&displayMode=${displayMode}`,
    method: "get"
  });
}
//获取所有的样式类型
export function listStyleType(params) {
  return request({
    url: `/style/listStyleType`,
    method: "get"
  });
}
//更具id查询信息
export function getStyleById(params) {
  return request({
    url: `/style/getById?id=${params.id}`,
    method: "get",
  });
}

//删除样式
export function deleteStyleById(params) {
  return request({
    url: `/style/delete`,
    method: "post",
    data: {
      id: params.id
    }
  });
}

//新增样式
export function createStyle(params) {
  return request({
    url: `/style/add`,
    method: "post",
    data: {
      styleCO: {
        name: params.name,
        styleType: params.styleType,
        displayMode: params.displayMode,
        isShowTitle: params.isShowTitle,
        columNum: params.columNum
      }
    }
  });
}
//修改样式
export function editStyle(id,params) {
  return request({
    url: `/style/update`,
    method: "post",
    data: {
      styleCO: {
        id,
        name: params.name,
        styleType: params.styleType,
        displayMode: params.displayMode,
        isShowTitle: params.isShowTitle,
        columNum: params.columNum
      }
    }
  });
}
